import { render, staticRenderFns } from "./shopping-cart-wizard-payment-method-step.vue?vue&type=template&id=3896399b&scoped=true&"
import script from "./shopping-cart-wizard-payment-method-step.vue?vue&type=script&lang=ts&"
export * from "./shopping-cart-wizard-payment-method-step.vue?vue&type=script&lang=ts&"
import style0 from "./shopping-cart-wizard-payment-method-step.vue?vue&type=style&index=0&id=3896399b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896399b",
  null
  
)

export default component.exports